import { useState } from 'react';
import {
  CategoryInformationElement,
  CountryInformationElement,
  DisabledStepsInformationElement,
  DyeingMediumInformationElement,
  FadingInformationElement,
  MaterialComplexityInformationElement,
  MaterialsInformationElement,
  NumberInformationElement,
  PrintingInformationElement,
  Reliability,
  SizesInformationElement,
  TextInformationElement,
} from './InformationElement';
import { sendDetailedProduct } from '../controller/productController';
import ModifiedProduct from '../model/ModifiedProduct';
import ReliabilityDetailsModel from '../model/ReliabilityDetailsModel';
import { validateForm } from '../utils/utils';
import hash from '../utils/hash/hash';
import UserModel, { userToString } from '../model/UserModel';
import Gears from '../icon/Gears';

interface FormProps {
  user: UserModel | undefined;
  id: string;
  name: string;
  id_product: string;
  site: string;
  color: string;
  category: string;
  sizes: any;
  weight: number;
  materials: any;
  country_fabric: string;
  country_dyeing: string;
  country_making: string;
  category_predicted: boolean;
  reliability_details: ReliabilityDetailsModel;
}

export default function Form(props: FormProps) {
  const [allInfo, setAllInfo] = useState<boolean>(false);
  const [modifying, setModifying] = useState<any>({
    color: false,
    category: false,
    sizes: false,
    weight: false,
    materials: false,
    country_fabric: false,
    country_dyeing: false,
    country_making: false,
    airTransportRatio: false,
    makingWaste: false,
    makingDeadStock: false,
    makingComplexity: false,
    yarnSize: false,
    surfaceMass: false,
    fading: false,
    disabledSteps: false,
    dyeingMedium: false,
    printing: false,
  });

  const [color, setColor] = useState<string>(props.color);
  const [category, setCategory] = useState<string>(props.category);
  const [sizes, setSizes] = useState<any>(props.sizes);
  const [weight, setWeight] = useState<string>(
    (props.weight * 1000).toString(),
  );
  const [materials, setMaterials] = useState<any>(props.materials);
  const [country_fabric, setCountryFabric] = useState<string>(
    props.country_fabric,
  );
  const [country_dyeing, setCountryDyeing] = useState<string>(
    props.country_dyeing,
  );
  const [country_making, setCountryMaking] = useState<string>(
    props.country_making,
  );

  const [transp_aer, setTranspAer] = useState<string>('');
  const [makingWaste, setMakingWaste] = useState<string>('');
  const [makingDeadStock, setMakingDeadStock] = useState<string>('');
  const [makingComplexity, setMakingComplexity] = useState<string>('');
  const [yarnSize, setYarnSize] = useState<string>('');
  const [surfaceMass, setSurfaceMass] = useState<string>('');
  const [fading, setFading] = useState<string>('');
  const [disabledSteps, setDisabledSteps] = useState<string[]>([]);
  const [dyeingMedium, setDyeingMedium] = useState<string>('');
  const [printing, setPrinting] = useState<any>({ pigment: 0, substantive: 0 });

  const [errorMessage, setErrorMessage] = useState<string>('');

  const [showPopup, setShowPopup] = useState<boolean>(false);

  return (
    <div className="md:text-xl xshort:text-sm text-sm">
      <TextInformationElement
        name="Couleur"
        value={color}
        setValue={setColor}
        reliability={Reliability.GOOD}
        modifying={modifying}
        id="color"
        setModifying={() => {}}
      />
      <hr className="text-darkLight dark:text-whiteLight my-6" />
      <CategoryInformationElement
        name="Catégorie"
        value={category}
        setValue={setCategory}
        reliability={
          props.category_predicted ? Reliability.MEDIUM : Reliability.GOOD
        }
        modifying={modifying}
        id="category"
        setModifying={() => {}}
      />
      <hr className="text-darkLight dark:text-whiteLight my-6" />
      <SizesInformationElement
        name="Tailles"
        value={sizes}
        setValue={setSizes}
        reliability={Reliability.GOOD}
        modifying={modifying}
        id="sizes"
        setModifying={() => {}}
      />
      <hr className="text-darkLight dark:text-whiteLight my-6" />
      <NumberInformationElement
        name="Poids"
        value={weight}
        setValue={setWeight}
        reliability={
          props.reliability_details.optimized_weight
            ? Reliability.GOOD
            : Reliability.MEDIUM
        }
        modifying={modifying}
        id="weight"
        setModifying={() => {}}
      />
      <hr className="text-darkLight dark:text-whiteLight my-6" />
      <MaterialsInformationElement
        name="Matériaux"
        value={materials}
        setValue={setMaterials}
        reliability={
          1 - props.reliability_details.unknown_material_proportion === 1
            ? Reliability.GOOD
            : 1 - props.reliability_details.unknown_material_proportion === 0
            ? Reliability.BAD
            : Reliability.MEDIUM
        }
        modifying={modifying}
        id="materials"
        setModifying={() => {}}
      />
      <hr className="text-darkLight dark:text-whiteLight my-6" />
      <CountryInformationElement
        name="Pays - Matières premières"
        value={country_fabric}
        setValue={setCountryFabric}
        reliability={
          props.reliability_details.unknown_country_fabric
            ? props.reliability_details.unknown_country_fabric_after_ml
              ? Reliability.BAD
              : Reliability.MEDIUM
            : Reliability.GOOD
        }
        modifying={modifying}
        id="country_fabric"
        setModifying={() => {}}
      />
      <hr className="text-darkLight dark:text-whiteLight my-6" />
      <CountryInformationElement
        name="Pays - Teinture"
        value={country_dyeing}
        setValue={setCountryDyeing}
        reliability={
          props.reliability_details.unknown_country_dyeing
            ? props.reliability_details.unknown_country_dyeing_after_ml
              ? Reliability.BAD
              : Reliability.MEDIUM
            : Reliability.GOOD
        }
        modifying={modifying}
        id="country_dyeing"
        setModifying={() => {}}
      />
      <hr className="text-darkLight dark:text-whiteLight my-6" />
      <CountryInformationElement
        name="Pays - Fabrication"
        value={country_making}
        setValue={setCountryMaking}
        reliability={
          props.reliability_details.unknown_country_making
            ? props.reliability_details.unknown_country_making_after_ml
              ? Reliability.BAD
              : Reliability.MEDIUM
            : Reliability.GOOD
        }
        modifying={modifying}
        id="country_making"
        setModifying={() => {}}
      />
      {!allInfo && (
        <div
          className="mt-4 hover:scale-105 transition-all duration-500 rounded-full flex flex-col justify-center items-center m-auto cursor-pointer"
          onClick={() => setAllInfo(true)}
        >
          <p className="text-sm">+ d'informations</p>
          <svg
            className="w-8 "
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
              fill="currentColor"
            />
          </svg>
        </div>
      )}
      {allInfo && (
        <div className="border-blackOverlay dark:border-whiteOverlay border-2 rounded-2xl p-6  mt-6">
          <div
            className="flex justify-center"
            onClick={() => setAllInfo(false)}
          >
            <svg
              className="w-8 cursor-pointer m-2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L6.53035 18.5303C6.23745 18.8232 5.76258 18.8232 5.46969 18.5303C5.17679 18.2374 5.17679 17.7626 5.46968 17.4697L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <NumberInformationElement
            name="Proportion de transport aérien"
            value={transp_aer}
            setValue={setTranspAer}
            reliability={Reliability.BAD}
            max={100}
            modifying={modifying}
            id="airTransportRatio"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <NumberInformationElement
            name="Taux de perte en confection"
            value={makingWaste}
            setValue={setMakingWaste}
            reliability={Reliability.BAD}
            max={100}
            modifying={modifying}
            id="makingWaste"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <NumberInformationElement
            name="Taux de stocks dormant"
            value={makingDeadStock}
            setValue={setMakingDeadStock}
            reliability={Reliability.BAD}
            max={100}
            modifying={modifying}
            id="makingDeadStock"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <MaterialComplexityInformationElement
            name="Complexité de confection"
            value={makingComplexity}
            setValue={setMakingComplexity}
            reliability={Reliability.BAD}
            modifying={modifying}
            id="makingComplexity"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <NumberInformationElement
            name="Titrage du fil (Nm)"
            value={yarnSize}
            setValue={setYarnSize}
            reliability={Reliability.BAD}
            modifying={modifying}
            id="yarnSize"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <NumberInformationElement
            name="Grammage de l'étoffe (gr/m²)"
            value={surfaceMass}
            setValue={setSurfaceMass}
            reliability={Reliability.BAD}
            max={500}
            min={80}
            modifying={modifying}
            id="surfaceMass"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <FadingInformationElement
            name="Délavage"
            value={fading}
            setValue={setFading}
            reliability={Reliability.BAD}
            modifying={modifying}
            id="fading"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <DisabledStepsInformationElement
            name="Étapes désactivées"
            value={disabledSteps}
            setValue={setDisabledSteps}
            reliability={Reliability.BAD}
            modifying={modifying}
            id="disabledSteps"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <DyeingMediumInformationElement
            name="Support teinté"
            value={dyeingMedium}
            setValue={setDyeingMedium}
            reliability={Reliability.BAD}
            modifying={modifying}
            id="dyeingMedium"
            setModifying={() => {}}
          />
          <hr className="text-darkLight dark:text-whiteLight my-6" />
          <PrintingInformationElement
            name="Type d'impression"
            value={printing}
            setValue={setPrinting}
            reliability={Reliability.BAD}
            modifying={modifying}
            id="printing"
            setModifying={() => {}}
          />
        </div>
      )}
      {/* {!Object.values(modifying).some((e) => e) && (
        <p className="italic text-center text-xs my-4">
          Chaque information est modifiable, n'hésitez pas à nous remonter les
          incohérences que vous remarquez !
        </p>
      )} */}
      {Object.values(modifying).some((e) => e) && (
        <div>
          {errorMessage !== '' && (
            <p className="text-center text-sm italic text-red-500 m-2">
              {errorMessage}
            </p>
          )}
          <div
            className="flex justify-center gap-8 items-center mt-4"
            onClick={() => {
              if (modifying.color && color !== props.color)
                setColor(props.color);
              if (modifying.category && category !== props.category)
                setCategory(props.category);
              if (
                modifying.sizes &&
                JSON.stringify(sizes) !== JSON.stringify(props.sizes)
              )
                setSizes(props.sizes);
              if (
                modifying.weight &&
                weight !== (props.weight * 1000).toString()
              )
                setWeight((props.weight * 10000).toString());
              if (
                modifying.materials &&
                JSON.stringify(materials) !== JSON.stringify(props.materials)
              )
                setMaterials(props.materials);
              if (
                modifying.country_fabric &&
                country_fabric !== props.country_fabric
              )
                setCountryFabric(props.country_fabric);
              if (
                modifying.country_dyeing &&
                country_dyeing !== props.country_dyeing
              )
                setCountryDyeing(props.country_dyeing);
              if (
                modifying.country_making &&
                country_making !== props.country_making
              )
                setCountryMaking(props.country_making);
              if (modifying.transp_aer && transp_aer !== '') setTranspAer('');
              if (modifying.makingWaste && makingWaste !== '')
                setMakingWaste('');
              if (modifying.makingDeadStock && makingDeadStock !== '')
                setMakingDeadStock('');
              if (modifying.makingComplexity && makingComplexity !== '')
                setMakingComplexity('');
              if (modifying.yarnSize && yarnSize !== '') setYarnSize('');
              if (modifying.surfaceMass && surfaceMass !== '')
                setSurfaceMass('');
              if (modifying.fading && fading !== '') setFading('');
              if (modifying.disabledSteps && disabledSteps.length > 0)
                setDisabledSteps([]);
              if (modifying.dyeingMedium && dyeingMedium !== '')
                setDyeingMedium('');
              if (
                modifying.printing &&
                (printing.pigment !== 0 || printing.substantive !== 0)
              )
                setPrinting({ pigment: 0, substantive: 0 });

              setErrorMessage('');
              const resetModifying = Object.keys(modifying).reduce(
                (acc, key) => ({
                  ...acc,
                  [key]: false,
                }),
                {},
              );
              setModifying(resetModifying);
            }}
          >
            <button className="bg-secondary p-3 px-6 rounded-full transition-all duration-500 hover:bg-secondaryDark">
              <p className="text-white text-lg text-center">Annuler</p>
            </button>
            <button
              className="bg-primary p-3 px-6 rounded-full transition-all duration-500 hover:bg-primaryDark"
              onClick={() => {
                const modifiedProduct: ModifiedProduct = {
                  user_id: hash(userToString(props.user!!)),
                  _id: props.id,
                  name: props.name,
                  id_product: props.id_product,
                  site: props.site,
                };
                if (modifying.color && color !== props.color)
                  modifiedProduct.color = color;
                if (modifying.category && category !== props.category)
                  modifiedProduct.category = category;
                if (
                  modifying.sizes &&
                  JSON.stringify(sizes) !== JSON.stringify(props.sizes)
                )
                  modifiedProduct.sizes = sizes;
                if (
                  modifying.weight &&
                  weight !== (props.weight * 1000).toString()
                ) {
                  modifiedProduct.weight = parseFloat(weight);
                }
                if (
                  modifying.materials &&
                  JSON.stringify(materials) !== JSON.stringify(props.materials)
                )
                  modifiedProduct.materials = materials;
                if (
                  modifying.country_fabric &&
                  country_fabric !== props.country_fabric
                )
                  modifiedProduct.country_fabric = country_fabric;
                if (
                  modifying.country_dyeing &&
                  country_dyeing !== props.country_dyeing
                )
                  modifiedProduct.country_dyeing = country_dyeing;
                if (
                  modifying.country_making &&
                  country_making !== props.country_making
                )
                  modifiedProduct.country_making = country_making;
                if (modifying.transp_aer && transp_aer !== '')
                  modifiedProduct.transp_aer = transp_aer;
                if (modifying.makingWaste && makingWaste !== '')
                  modifiedProduct.makingWaste = makingWaste;
                if (modifying.makingDeadStock && makingDeadStock !== '')
                  modifiedProduct.makingDeadStock = makingDeadStock;
                if (modifying.makingComplexity && makingComplexity !== '')
                  modifiedProduct.makingComplexity = makingComplexity;
                if (modifying.yarnSize && yarnSize !== '')
                  modifiedProduct.yarnSize = yarnSize;
                if (modifying.surfaceMass && surfaceMass !== '')
                  modifiedProduct.surfaceMass = surfaceMass;
                if (modifying.fading && fading !== '')
                  modifiedProduct.fading = fading;
                if (modifying.disabledSteps && disabledSteps.length > 0)
                  modifiedProduct.disabledSteps = disabledSteps;
                if (modifying.dyeingMedium && dyeingMedium !== '')
                  modifiedProduct.dyeingMedium = dyeingMedium;
                if (
                  modifying.printing &&
                  (printing.pigment !== 0 || printing.substantive !== 0)
                )
                  modifiedProduct.printing = printing;

                if (!validateForm(modifiedProduct, setErrorMessage)) {
                  return;
                }
                setErrorMessage('');
                const resetModifying = Object.keys(modifying).reduce(
                  (acc, key) => ({
                    ...acc,
                    [key]: false,
                  }),
                  {},
                );
                setModifying(resetModifying);

                sendDetailedProduct(modifiedProduct);

                setShowPopup(true);
              }}
            >
              <p className="text-white text-lg text-center">Confirmer</p>
            </button>
          </div>
        </div>
      )}
      {showPopup && (
        <div className="absolute w-72 md:w-[330px]  top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] z-20 bg-white dark:bg-black rounded-3xl">
          <div className="w-full h-full bg-blackOverlay dark:bg-whiteOverlay rounded-3xl p-6 flex flex-col gap-3">
            <p className="text-center text-2xl font-bold">
              Merci pour votre contribution !
            </p>
            <p className="text-center text-lg">
              Vos données sont en cours de traitement...
            </p>
            <Gears />

            <div
              onClick={() => setShowPopup(false)}
              className="bg-primary rounded-2xl p-2 w-2/3 m-auto my-2 cursor-pointer transition-all hover:bg-secondary hover:scale-105"
            >
              <p className="text-center">Ok</p>
            </div>
          </div>
        </div>
      )}
      {showPopup && (
        <div
          className="absolute top-0 left-0 w-full h-full bg-blackLight z-10"
          onClick={() => setShowPopup(false)}
        ></div>
      )}
    </div>
  );
}
